export default {"src":"/_next/static/media/hangers.7b624a82.svg","height":100,"width":100};